import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bashboard_company_up",
  "use": "icon-bashboard_company_up-usage",
  "viewBox": "0 0 82 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 82 36\" id=\"icon-bashboard_company_up\">\n<polygon points=\"82,6.4 81.9,0.5 75.5,0.5 78.4,3.1 49.6,26.6 27.6,7.6 0,34.1 1.4,35.5 27.7,10.3 49.5,29.2 79.9,4.5 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol